<template>
  <div class="modatta-companies-hero modatta-home-hero">
    <div class="modatta-container">
      <div class="columns">
        <div class="column is-half">
          <h3 v-html="$t('companies.section_1_subtitle')"></h3>
          <!--<h1 v-html="$t('companies.section_1_title')"></h1>-->
          <h1>
          <brands-title v-html="$t('companies.section_1_title')"></brands-title>
          </h1>
          <button
            class="modatta-button modatta-button--blue"
            @click="scrollToSection"
            v-html="$t('companies.section_3_button_howto')"
          ></button>
        </div>
        <div class="column"></div>
      </div>
      <div class="hero-image">
        <div class="image-container">
          <img
            src="/img/companies-hero.png"
            alt="Image of a Woman and a Man Using the Modatta Portal"
          />
        </div>
        <div class="oval"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    scrollToSection() {
      const element = document.querySelector('section.section-3');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    },
  },
};
</script>